import React, { useState } from "react";
import "./LogsPage.css";

import EmailLogs from "../Emails/EmailsLogs";
import ApplicationLogs from "./ApplicationLogs";

const LogsPage = () => {
    const [activeTab, setActiveTab] = useState("APP");

    return (
        <div className="logs-page">
            <div className="logs-page-header">
                <div>
                    <h2>Historique & journaux</h2>
                    <p>Consultez les logs applicatifs et les logs des emails envoyés.</p>
                </div>
            </div>

            <div className="logs-tabs">
                <button
                    className={`logs-tab ${activeTab === "APP" ? "active" : ""}`}
                    onClick={() => setActiveTab("APP")}
                >
                    Logs applicatifs
                </button>

                <button
                    className={`logs-tab ${activeTab === "EMAIL" ? "active" : ""}`}
                    onClick={() => setActiveTab("EMAIL")}
                >
                    Logs des emails
                </button>
            </div>

            <div className="logs-tab-content">
                {activeTab === "APP" ? <ApplicationLogs /> : <EmailLogs />}
            </div>
        </div>
    );
};

export default LogsPage;